export function weightFormatter(v: number) {
    const weight = new Intl.NumberFormat('sv-SE', {
        unit: 'kilogram',
        maximumFractionDigits: 2,
    })
    let val = weight.format(v)
    val = val.replace(/(,[0-9])$/, '$10') // Pad to two zeros
    return val.replace('−', '-') // Replace big minus with normal dash
}